import results from '@/sui/data/results'
import pdf from '@/sui/tools/pdf'

import ctool from 'color'

function qColor (q, b) {
  const qc = results.qualities[q]
  let c = ctool(qc.color)
  if (qc.opacity !== 1) {
    c = c.lighten(1.0 - qc.opacity)
  }

  if (!b) {
    c = c.lighten(0.3)
  }

  return c.hex()
}

function getUnitList (vm, sc, filter) {
  const list = {}

  const t = vm.infectionType.code
  const units = vm.results.units[t]
  const checkScope = function (d, u) {
    for (let e in results.entrances[t]) {
      const key = results.getIncidenceKey(
        { den: d, ent: e, spe: u.spe, uf: u.uf, inf: t, disc: u.disc }
      )
      const inc = vm.incidences[key]
      if (inc != null) {
        return true
      }
    }
  }
  const all = '__all__'
  const specialities = Object.values(vm.specialities)

  for (let d in units) {
    const reducer = (result, u) => {
      if (filter(vm, u) && checkScope(d, u)) {
        const spe = specialities.find(
          s => (u.spe === '__all__' && s.code === u.disc) ||
            (s.code === u.spe && u.spe !== u.disc)
        )
        if (spe == null) {
          return result
        }

        const label = spe.subtitle == null ? spe.code : `${spe.code} (${spe.subtitle})`
        result.push({
          src: u,
          uf: u.uf,
          label: label,
          spe: u.spe
        })
      }
      return result
    }
    list[d] = units[d].reduce(reducer, []).sort(
      (f, s) => {
        const compare = f.label.localeCompare(s.label)
        if (compare === 0) {
          if (f.uf === all) {
            return -1
          } else if (s.uf === all) {
            return 1
          }
          return f.uf.localeCompare(s.uf)
        }
        return compare
      }
    )
  }
  return list
}

function meanCell (m) {
  return {
    text: `(${m})`,
    style: ['mean', 'center'],
    noWrap: true
  }
}

function valueCell (v, q) {
  const s = [
    'center',
    `q${v > 0 ? `${q}vhl` : q}`
  ]
  return {
    text: ` ${v} `,
    noWrap: true,
    style: s
  }
}

function legend () {
  const meanNat = () => {
    return {
      text: `(moyenne nationale)`,
      noWrap: true,
      style: 'mean'
    }
  }

  const label = (e) => {
    return { text: e, style: 'bold' }
  }

  const justify = (t) => {
    return { text: t, style: 'justified' }
  }

  return {
    layout: 'lightHorizontalLines',
    dontBreakRows: true,
    fontSize: 9,
    table: {
      headerRows: 1,
      widths: [ 'auto', 25, '*' ],
      body: [
        [
          {
            text: 'Légende',
            colSpan: 3,
            style: 'h2'
          }, {}, {}
        ],
        [
          [ label('Valeur dans la norme'), meanNat() ],
          [ valueCell(0.20, 0), meanCell(0.50) ],
          justify(
            `La valeur n'est pas anormalement élevée en comparaison des établissements participants de même type.`
          )
        ],
        [
          [ label('Valeur «outlier»'), meanNat() ],
          [ valueCell(2.50, 2), meanCell(0.45) ],
          [
            label('Valeur > q3 + (q3 - q1) * 1.5 ou Valeur < q1 - (q3 - q1) * 1.5'),
            justify(
              `La valeur est élevée ou basse par rapport à celles des établissements de même type. Nous vous invitons à analyser les causes possibles de l'écart.`
            )
          ]
        ],
        [
          [ label('Valeur seule'), meanNat() ],
          [ valueCell(0.33, 1), meanCell(0.33) ],
          justify(
            `La valeur est seule dans sa catégorie et ne peut pas être comparée avec d'autres.`
          )
        ],
        [
          [ label('Valeur peu vraisemblante'), meanNat() ],
          [ valueCell(522.0, 3), meanCell(8.2) ],
          [
            label('Valeur > 20%'),
            justify(
              `La valeur est non vraisemblante et n'a pas été retenue dans les résultats nationaux. Nous vous invitons à vérifier les fiches saisies et les dénominateurs renseignés sur la fiche établissement.`
            )
          ]
        ],
        [
          [
            label('Valeur non comparée'), meanNat() ],
          [ valueCell(0.33, 4), {} ],
          [
            justify(
              `La valeur n'est pas comparable à la population de référence, par exemple si les données sont filtrées.`
            )
          ]
        ],
        [
          [
            label('Valeur partielle'), meanNat() ],
          [ valueCell(0.33, 5), {} ],
          [
            justify(
              `La valeur est partielle car l'utilisateur n'a pas les droits de visibilité sur
      l'ensemble des modalités où la spécialité a été surveillée.`
            )
          ]
        ]
      ]
    }
  }
}

function exportPDF (vm, sc, f, o) {
  const styles = {
    h1: {
      fontSize: 20,
      color: '#0b89c0'
    },

    h2: {
      fontSize: 14,
      margin: [0, 20, 0, 5],
      color: '#0b89c0'
    },

    columnHeader: {
      fontSize: 8
    },

    center: {
      alignment: 'center'
    },

    mean: {
      fontSize: 7
    },
    q0: {
      background: qColor(0),
      color: 'white'
    },
    q1: {
      background: qColor(1),
      color: 'white'
    },
    q2: {
      background: qColor(2),
      color: 'white'
    },
    q3: {
      background: qColor(3),
      color: 'white'
    },
    q4: {
      background: qColor(4),
      color: 'white'
    },
    q5: {
      background: qColor(5),
      color: 'white'
    },

    q0vhl: {
      background: qColor(0, true),
      color: 'white'
    },
    q1vhl: {
      background: qColor(1, true),
      color: 'white'
    },
    q2vhl: {
      background: qColor(2, true),
      color: 'white'
    },
    q3vhl: {
      background: qColor(3, true),
      color: 'white'
    },
    q4vhl: {
      background: qColor(4, true),
      color: 'white'
    },
    q5vhl: {
      background: qColor(5, true),
      color: 'white'
    },
    bold: {
      bold: true
    }
  }

  const content = [
    { text: vm.chartTitle, style: 'h1' }
  ]
  if (o.legend) {
    content.push(legend())
  }
  const unitList = getUnitList(vm, sc, f)

  const t = vm.infectionType.code
  for (let i in results.denominators[t]) {
    const d = results.denominators[t][i]
    const list = unitList[i]
    if (list != null && list.length > 0) {
      const ref = results.pdf[t]
      const refw = t === 'bact' ? 36 : '*'

      let needTitle = true
      for (let r in ref) {
        const headers = [
          { text: 'Discipline', style: 'columnHeader' }
        ]
        const widths = [ o.showUfs ? 80 : '*' ]
        if (o.showUfs) {
          headers.push({ text: 'UF', style: [ 'columnHeader', 'center' ] })
          widths.push(70)
        }
        headers.push({})
        widths.push('*')

        const refe = ref[r]
        let count = 0
        for (let k in refe) {
          const e = refe[k]
          const entrance = results.entrances[t][e]

          if (entrance.year > vm.year) {
            continue
          }

          count += 1
          const short = entrance.short
          const title = entrance.title
          headers.push(
            {
              text: short != null ? short : title,
              style: [ 'center', 'columnHeader' ]
            }
          )
          widths.push(refw)
        }

        const body = []
        if (needTitle) {
          const titleHeader = [
            {
              text: `Taux d'incidence des ${vm.infectionType.subtitle} pour ${d.label}`,
              style: [ 'h2' ]
            }
          ]
          if (o.showUfs) {
            titleHeader.push({})
          }
          titleHeader.push({})

          for (let i = 0; i !== count; ++i) {
            titleHeader.push({})
          }

          titleHeader[0].colSpan = titleHeader.length
          body.push(titleHeader)
        }
        body.push(headers)

        let withValue = false
        list.forEach(
          l => {
            const line = [
              l.label
            ]
            if (o.showUfs) {
              if (l.uf === '__all__') {
                line.push([{ text: '-', style: 'center' }])
              } else {
                const par = l.uf.lastIndexOf('(')
                const fl = par === -1 ? l.uf : l.uf.substr(0, par)
                line.push([{ text: fl, style: 'center' }])
              }
            }
            line.push({})
            for (let k in refe) {
              const e = refe[k]
              const entrance = results.entrances[t][e]
              if (entrance.year > vm.year) {
                continue
              }

              const key = results.getIncidenceKey(
                { den: i, ent: e, spe: l.spe, uf: l.uf, inf: t, disc: l.src.disc }
              )
              const value = vm.incidences[key]
              if (value == null) {
                line.push('')
              } else {
                withValue = true
                const l = [
                  valueCell(results.fixDecimals(value.incidence), value.quality),
                  o.showMean && value.mean >= 0 ? meanCell(results.fixDecimals(value.mean)) : {}
                ]
                line.push(l)
              }
            }
            body.push(line)
          }
        )

        if (withValue) {
          const headerLines = needTitle ? 2 : 1
          needTitle = false
          content.push(
            {
              fontSize: 9,
              margin: [0, 10],
              layout: {
                hLineWidth: function (i, node) {
                  return i < headerLines ? 0 : i === headerLines ? 2 : 1
                },

                vLineWidth: function (i, node) {
                  return 0
                },

                hLineColor: function (i, node) {
                  return i === headerLines ? 'black' : 'gray'
                },

                paddingLeft (i) {
                  return i === 0 ? 0 : 1
                },

                paddingRight (i, node) {
                  return (i < node.table.widths.length - 1) ? 1 : 0
                }
              },
              table: {
                dontBreakRows: true,
                widths: widths,
                body: body
              }
            },
            {}
          )
        }
      }
    }
  }

  const definition = {
    pageStyle: 'A4',
    pageOrientation: 'landscape',
    content: content,
    styles: styles,
    footer: (current, count) => {
      return {
        text: `${vm.chartTitle} - page ${current}/${count}`,
        fontSize: 6,
        alignment: 'center'
      }
    }
  }
  const filename = `${vm.chartTitle}.pdf`
  pdf.createPdf(definition).download(filename)
}

export default {
  exportPDF: exportPDF
}
